import "angular";
import "angular-translate";
import "angular-translate-loader-static-files";
import "angular-resource";
import "angular-cookies";
import AccuCodeService from "../layout/service/AccuCodeService";
import TranslateService from "./TranslateService";
import TranslateConfig from "./TranslateConfig";

const TranslateServiceModule = angular
    .module("TranslateServiceModule", [
        "pascalprecht.translate",
        "ngResource",
        "LayoutModule",
        "ngCookies"
    ])
    .service("AccuCodeService", AccuCodeService)
    .service("translateService", TranslateService)
    .config(TranslateConfig);

export default TranslateServiceModule;
